<template>
    <div id="app-layout">
        <nav-header />

        <particles />

        <div id="wrap">
            <main role="main" class="container">
                <div class="row">
                    <div class="col">
                        <div id="content-wrapper" class="full-height">
                            <div class="row full-height">
                                <div class="col col-sm-3 full-height">
                                    <side-nav />
                                </div>
                                <div class="col">
                                    <div id="content">
                                        <oc-flash-messages class="mt-2" />

                                        <slot></slot>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>

        <Footer />
    </div>
</template>

<script>
import NavHeader from "@/layout/parts/NavHeader"
import SideNav from "@/layout/parts/SideNav"
import Particles from "@/layout/parts/Particles"
import Footer from "@/layout/parts/Footer"

export default {
    name: "AppLayout",
    components: {
        NavHeader,
        SideNav,
        Footer,
        Particles
    }
}
</script>

<style scoped>
#wrap {
    min-height: 100%;
    height: auto;
    margin: 0 auto;
    padding: 0 0 61px;
}

.container {
    padding: 20px 15px 20px 15px;
}

#content-wrapper {
    background: #fff;
    position: relative;
    z-index: 1;
    min-height: 408px;
    border: 1px solid #ccc;
    border-radius: 3px;
}

#content {
    padding: 5px 15px 15px 0;
}

.full-height {
    height: 100%;
}
</style>
